import { format, addHours } from "date-fns";

export const dayOptions = [
  { value: "*", label: "Tous les jours" },
  { value: "1", label: "Tous les lundis" },
  { value: "2", label: "Tous les mardis" },
  { value: "3", label: "Tous les mercredis" },
  { value: "4", label: "Tous les jeudis" },
  { value: "5", label: "Tous les vendredis" },
  { value: "6", label: "Tous les samedis" },
  { value: "0", label: "Tous les dimanches" },
];

export const hourOptions = Array.from({ length: 24 }, (_, i) => ({
  value: i.toString(),
  label: format(new Date().setHours(i, 0, 0), "HH:00"),
}));

export const minuteOptions = [
  { value: "0", label: "00" },
  { value: "15", label: "15" },
  { value: "30", label: "30" },
  { value: "45", label: "45" },
];

export const convertToCronExpression = (day: string, hour: string, minute: string): string => {
  // Convertir l'heure de Cayenne (UTC-3) en UTC
  const utcHour = (parseInt(hour) + 3) % 24;
  return `${minute} ${utcHour} * * ${day}`;
};

const findClosestMinute = (minute: string): string => {
  const minuteNumber = parseInt(minute);
  const availableMinutes = minuteOptions.map(opt => parseInt(opt.value));
  
  // Trouver la valeur la plus proche
  return availableMinutes.reduce((prev, curr) => {
    return Math.abs(curr - minuteNumber) < Math.abs(prev - minuteNumber) ? curr : prev;
  }, availableMinutes[0]).toString();
};

const isValidDay = (day: string): boolean => {
  return dayOptions.some(option => option.value === day);
};

export const parseExistingCron = (cronExpression: string) => {
  console.log("Parsing cron expression:", cronExpression);
  const [minute, hour, , , day] = cronExpression.split(" ");
  
  // Convertir l'heure UTC en heure de Cayenne (UTC-3)
  const cayenneHour = ((parseInt(hour) - 3 + 24) % 24).toString().padStart(2, '0');
  console.log("Converted UTC hour", hour, "to Cayenne hour:", cayenneHour);
  
  // Trouver la minute la plus proche dans nos options
  const normalizedMinute = findClosestMinute(minute);
  console.log("Normalized minute from", minute, "to:", normalizedMinute);
  
  // Valider le jour, utiliser "*" si invalide
  const normalizedDay = isValidDay(day) ? day : "*";
  console.log("Normalized day from", day, "to:", normalizedDay);
  
  return {
    day: normalizedDay,
    hour: cayenneHour,
    minute: normalizedMinute,
  };
};